export default "__VITE_ASSET__Bj$Aqg_q__"